import { Button } from "@/components/ui/button"
import modalStyles from "../modals.module.scss"
import styles from "./styles.module.scss"
import { useAutoTranslation, useModalStore } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS } from "@/shared/constants"
import { Modal } from "@/shared/types"
import { Controller } from "react-hook-form"
import { useCreateNoteText } from "@/features"
import { Label } from "@/components/ui/label"
import { TypographyH2 } from "@/components/ui/typography"
import { Textarea } from "@/components/ui/textarea"
import { useEffect } from "react"

export const CreateContentWithTextModal = () => {
  const { t } = useAutoTranslation()
  const { control, errors, handleSubmit } = useCreateNoteText()
  const handleClose = () => {
    useModalStore.getState().closeModal(Modal.CREATE_CONTENT_WITH_TEXT)
  }

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleClose()
      }
    }

    window.addEventListener("keydown", handleKeyPress)
    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [])

  return (
    <div className={modalStyles.backdrop} onClick={handleClose}>
      <div className={styles.wrapper}>
        <div className={styles.card} onClick={e => e.stopPropagation()}>
          <TypographyH2 className={styles.title}>
            {t(DISCOVERED_TRANSLATION_KEYS.CREATE_CONTENT_WITH_TEXT)}
          </TypographyH2>

          <form
            onSubmit={handleSubmit}
            className="flex min-h-0 w-full flex-1 flex-col gap-4"
          >
            <Controller
              control={control}
              name="text"
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <div className="flex min-h-0 w-full flex-1 flex-col gap-2">
                  <Label htmlFor="create-content-with-text-text">
                    {t(DISCOVERED_TRANSLATION_KEYS.PROVIDE_TEXT_TO_CONVERT)}
                  </Label>
                  <Textarea
                    autoFocus
                    id="create-content-with-text-text"
                    value={field.value}
                    onChange={field.onChange}
                    placeholder={t(DISCOVERED_TRANSLATION_KEYS.ENTER_TEXT_HERE)}
                    aria-invalid={!!errors.text}
                    className="field-sizing-fixed min-h-0 w-full flex-1 resize-none overflow-y-auto"
                  />
                </div>
              )}
            />
            <Button type="submit" className="w-full">
              {t(DISCOVERED_TRANSLATION_KEYS.CREATE)}
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}
